<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row>
          <v-col cols="12" class="pa-8">
            <v-btn 
              @click="newTypeOfSponsor"
              color="primary">
              Nuevo tipo de Sponsor
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              class="pt-8"
              :headers="headers"
              :items="sponsors"
              :custom-filter="customSearch"
              :items-per-page="30"
              :header-props="headerProps"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100],
                'items-per-page-text':'Tipos de sponsors por página',
              }"
              mobile="true"
            >
              <template v-slot:item.is_visible="{ item }">
                <td class="text-center">{{ item.is_visible==1?'Visible':'No visible' }}</td>
              </template>
              <template v-slot:item.actions="{ item }">
                <td class="text-center">
                  
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    outlined
                    color="black"
                    @click="moveUp(item.id)"
                  >
                    <v-icon dark small>
                      mdi-arrow-up
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    outlined
                    color="black"
                    @click="moveDown(item.id)"
                  >
                    <v-icon dark small>
                      mdi-arrow-down
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="info"
                    :to="{ name: 'sponsorsEdition', params: {edition_id:edition_id, types_sponsor_id: item.id } }"
                  >
                    <v-icon dark small>
                      mdi-format-list-bulleted
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="warning"
                    @click="editTypeOfSponsor(item.id)"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    @click="confirmDeleteEdition(item.id)"
                  >
                    <v-icon dark small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        color="primary"
        :to="{ name: 'showAllSponsorsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-eye
        </v-icon>
        Vista previa
      </v-btn>
    </v-col>

    <v-dialog
        v-model="loading"
        overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            <label>Cargando...</label>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog_new"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h6">
            NUEVO TIPO DE SPONSOR
          </v-card-title>

          <v-card-text class="pa-8">
            <v-text-field label="Nombre" v-model="name"></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog_new=!dialog_new"
            >
              Cerrar
            </v-btn>
            <v-btn
              color="primary"
              text
              :disabled="!name"
              :loading="dialog_new_edition"
              @click="create"
            >
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog_edit"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h5 lighten-2">
            Editar tipo de patrocinador 
          </v-card-title>

          <v-card-text class="pa-8">
            <v-row>
              <v-col cols="8">
                <v-text-field label="Nombre" v-model="name"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-switch
                  v-model="is_visible"
                  :label="(is_visible)?'Visible':'No visible'"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog_edit = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              :loading="loading_edit"
              @click="updateTypeOfSponsor"
            >
              Actualizar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog_delete"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h5 lighten-2">
            Atención 
          </v-card-title>

          <v-card-text class="pt-4 pb-6">
            ¿Está seguro que desea borrar este tipo de patrocinador? Todo los patrocinadores
            relacionados a este tipo se borraran también.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog_delete = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="deleteTypeOfSponsor"
            >
              Borrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Editions',

    data: () => ({
      loading:true,
      loading_edit: false,
      show:false,
      
      dialog_new:false,
      dialog_new_edition:false,
      dialog_edit:false,
      dialog_delete:false,
      edit_id:null,
      delete_id:null,
      name:'',
      is_visible:false,

      edition_id: false,

      sponsors:[],
      sponsor:[],

      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'order',
          width: '5%'
        },
        {
          text: 'Tipo de sponsor',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '40%'
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: true,
          value: 'is_visible',
          width: '15%'
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '40%'
        }
      ],

      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      },
      
      filterOnlyCapsText (value, search, item) {
        console.log(item)
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      },

      async getTypesOfSponsors()
      {
        await axios.get('admin/editions/'+this.edition_id+'/types-sponsors').then(response =>{
          this.sponsors = response.data.data.sponsors
          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      newTypeOfSponsor()
      {
        this.name = ''
        this.dialog_new = true
      },

      async create()
      {
        try {
          this.dialog_new_edition = true
          await axios.post('admin/editions/'+this.edition_id+'/types-sponsors',{
            name: this.name, 
            edition_id: this.edition_id
            }).then(() =>{
              this.dialog_new_edition = false
              this.dialog_new = false
              this.loading = true
              this.getTypesOfSponsors()
            })
          } catch (error) {
            this.dialog_new_edition = false
            console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          }
      },

      showTypeOfSponsor(id)
      {
        alert(id)
        // this.$router.push({ name: 'show', params: { edition_id: id } })
      },

      entrepreneurshipsEdition(id)
      {
        this.$router.push({ name: 'entrepreneurshipsEdition', params: { edition_id: id } })
      },

      async editTypeOfSponsor(id)
      {
        this.loading = true
        this.loading_edit = false
        this.edit_id = id
        await axios.get('admin/editions/'+this.edition_id+'/types-sponsors/'+this.edit_id).then(response =>{
          this.types_of_sponsor = response.data.data.types_of_sponsor
          this.name = this.types_of_sponsor.name
          this.is_visible = this.types_of_sponsor.is_visible
          this.loading=false
          this.dialog_edit = true
        }).catch(error => {
          console.log(error);
        })
      },

      async updateTypeOfSponsor()
      {
        this.loading_edit = true
        await axios.put('admin/editions/'+this.edition_id+'/types-sponsors/'+this.edit_id, {
          name: this.name,
          is_visible: this.is_visible
        }).then(() =>{
          this.getTypesOfSponsors()
          this.loading = true
          this.loading_edit = false
          this.dialog_edit = false
        }).catch(error => {
          console.log(error);
        })
      },

      confirmDeleteEdition(id)
      {
        this.dialog_delete = true
        this.delete_id = id
      },

      async deleteTypeOfSponsor()
      {
        this.dialog_delete = false
        try {
          this.loading=true
          await axios.delete('admin/editions/'+this.edition_id+'/types-sponsors/'+this.delete_id).then(() =>{
            this.loading = true
            this.getTypesOfSponsors()
            this.delete_id = null
          })
        } catch (error) {
          console.error(error.response.data);
        }
      },

      async moveUp(id){
        this.loading = true
        try{
          await axios.put('admin/editions/'+this.edition_id+'/types-sponsors/'+id+'/move-up', {
            edition_id: this.edition_id
          }).then(()=>{
            this.getTypesOfSponsors()
          })
        }catch(error) {
          this.loading = false
          console.log(error)
        }
      },
      
      async moveDown(id){
        this.loading = true
        try{
          await axios.put('admin/editions/'+this.edition_id+'/types-sponsors/'+id+'/move-down', {
            edition_id: this.edition_id
          }).then(()=>{
            this.getTypesOfSponsors()
          })
        }catch(error) {
          this.loading = false
          console.log(error)
        }
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getTypesOfSponsors()
    },
  }
</script>
